/** @format */

import { useGlobalStoreWithOut } from '@/store/modules/global';

/**
 * 是否有按钮的权限
 * @param {string|Array<object>} value
 * @returns {boolean|Array<object>}
 */
export function hasButtonPermission(value) {
	const permissions = new Set(useGlobalStoreWithOut().userInfo.permissions);
	const allPermission = '*:*:*';

	if (value === undefined || value === null) {
		return false;
	}

	if (permissions.has(allPermission)) {
		return typeof value === 'string' ? true : value;
	}

	if (typeof value === 'string') {
		return permissions.has(value);
	} else {
		return value.filter((item) => !item.permission || permissions.has(item.permission));
	}
}
